<template>
  <LoaderWrapper ref="loader" class="h-100">
    <section class=" min-vh-100">
      <div class="container d-flex flex-column">
        <div class="row text-end mt-3">
          <div class="dropdown">
            <a class="btn btn-outline-secondary dropdown-toggle text-capitalize" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ lang }}
            </a>
            <ul class="dropdown-menu" style="min-width: 0;">
              <li v-for="language in ['en', 'ru']"><a class="dropdown-item text-capitalize" @click.prevent="changeLang(language)" href="#">{{ language }}</a></li>
            </ul>
          </div>
        </div>
        <div class="row align-items-center justify-content-center">
          <div class="col-md-6 col-lg-5 col-xl-4 py-6 py-md-0">
            <div>
              <div class="mb-4 text-center"><h6 class="h3 mb-1 text-capitalize-first">{{ helper.trans('labels.invitation_form_title') }}</h6>
                <p v-if="invite" class="text-muted mb-0">{{ helper.trans('labels.invite_set_password') }}</p></div>
              <span class="clearfix"></span>
              <form v-if="invite" method="post" name="login-form-merchant-p2p">
                <div class="form-group"><label class="form-control-label text-capitalize-first">{{ helper.trans('labels.login') }}</label>
                  <div class="input-group input-group-merge">
                    <input type="text"
                           v-model="invite!.user.email"
                           readonly
                           class="form-control form-control-prepend"
                           id="input-username"
                           name="username" required
                           :placeholder="helper.trans('labels.login')"
                    >
                    <div class="input-group-prepend"><span class=""><svg
                      xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="feather feather-user"><path
                      d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle
                      cx="12" cy="7" r="4"></circle></svg></span></div>
                  </div>
                </div>
                <div class="form-group mb-0 mt-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <div><label class="form-control-label text-capitalize-first">{{ helper.trans('labels.password') }}</label></div>

                  </div>
                  <div class="">
                    <FormInputWrapper v-slot="parentProps" :errors="getErrors(`password`)">
                      <input type="password"
                             v-model="request.password"
                             class="form-control form-control-prepend"
                             :class="parentProps.class"
                             id="input-password"
                             name="password"
                             :placeholder="helper.trans('labels.password')">
                    </FormInputWrapper>
                  </div>
                </div>
                <div class="form-group mb-0 mt-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <div><label class="form-control-label text-capitalize-first">{{ helper.trans('labels.confirm_password') }}</label></div>

                  </div>
                  <div class="">
                    <FormInputWrapper v-slot="parentProps" :errors="getErrors(`passwordConfirm`)">
                      <input type="password"
                             v-model="request.passwordConfirm"
                             class="form-control form-control-prepend"
                             :class="parentProps.class"
                             id="input-password"
                             name="password_confirm"
                             :placeholder="helper.trans('labels.confirm_password')">
                    </FormInputWrapper>

                  </div>
                </div>
                <div class="mt-4">
                  <button @click.prevent="save()" type="submit" class="btn w-100 btn-success text-capitalize-first">{{helper.trans('button.create_account')}}</button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import {useRoute} from "vue-router";
import InviteRequestDTO from "@/models/InviteRequestDTO";
import InviteRequestUserRequestDTO from "@/models/request/InviteRequestUserRequestDTO";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {UserRole} from "@/models/enum/UserRole";
import router from "@/router";

const api = new APIClient();
const notification = useNotification()

const redirectTo = (role: any) => {
  switch (role) {
    case UserRole.TRADER:
    case UserRole.MERCHANT:
    case UserRole.MERCHANT_OPERATOR:
      return '/';
    case UserRole.OPERATOR:
      return '/deals';
    case UserRole.ADMIN:
      return '/admin/accounts';
    default:
      return '/';
  }
}

export default defineComponent({
  components: {
    LoaderWrapper,
    FormInputWrapper
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)



    const state = reactive({
      lang: window.userLang,
      invite: null as InviteRequestDTO|null,
      request: {
        password: "",
        passwordConfirm: ""
      } as InviteRequestUserRequestDTO,
      errors: {} as ValidationErrorDTO[]|any,
    });

    const changeLang = (lang: string) => {
      helper.setLang(lang)
      state.lang = lang
    }

    onMounted(async () => {
      loader.value?.show()
      if (route.params.token) {
        try {
          state.invite = await api.getInviteRequest(route.params.token as string)
        } catch (e) {
          notification.notify({title: "not found or expired"})
          setTimeout(() => {
            router.push("/");
          }, 1000)
        }

      }
      loader.value?.hide()
    });

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const save = async () => {
      state.errors = [];
      loader.value?.show()
      try {
        state.request.lang = window.userLang
        const accessToken = await api.useInviteRequest(state.invite!.token, state.request)
        await store.dispatch('useAccessToken', accessToken);
        await store.dispatch('loadUser');
        router.push(redirectTo(store.getters["getRole"]));
      } catch (e: any) {
        if (e.response && e.request && e.request.status === 400 && e.response.data) {
          setErrors(e.response.data)
        } else {
          console.log(e);
        }
      }
      loader.value?.hide()
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    return {
      ...toRefs(state),
      getErrors,
      changeLang,
      save,
      loader,
      dateHelper,
      numberFormatter,
      helper,
    }
  }
})
</script>
